<template>
  <div :class="isShowMe?'orderDetails':'orderDetails hide'">
    <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
   
    <div class="detailList">
			<div class="dl-top">
				<div class="dl-title fl">{{DetailData[0].Title}}</div>
				<div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
			</div>
    
      <el-tabs v-model="activeName" class="eltabs" @tab-click="tabsHandleClick">
        <el-tab-pane label="订单详情" name="first">
           <div class="orderinfo">
              <el-row align="middle" type="flex" > 
              <el-col :span="20"><div class="grid-content bg-purple">订单号:{{SerialNo}}</div></el-col>
              <el-col :span="4"><div class="grid-content bg-purple fr"><span>{{Status}}</span></div></el-col>
            </el-row>
             <el-row align="middle" type="flex" > 
              <el-col :span="5"><div class="grid-content bg-purple">单价:{{DetailData[0].Price}}元</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple">保证金:{{DetailData[0].Ensure}}元</div></el-col>
              <el-col :span="14" v-if="OrderType==2"><div class="grid-content bg-purple">保费:{{DetailData[0].Premium}}元</div></el-col>
            </el-row>
           </div>

           <div :class="OrderType==1?'unlockWx hide':'unlockWx'">
             <h2>解封微信号</h2><em>（需添加好友的微信号）</em>
             <div class="weixin">{{DetailData[0].UnlockWx1}}</div>
           </div>

           <div class="unlockWxOne" v-if="DetailData[0].UnlockWx!='' && DetailData[0].UnlockWx!=null">
             解封微信号：{{DetailData[0].UnlockWx}}
           </div>

            <div :class="OrderType==1?'wxqun hide':'wxqun'">
             <h2>微信群二维码</h2><em>（必须发布微信群二维码,禁止广告及欺骗行为,否则官方有权冻结账号与资金）</em>
             <div class="ewm"><img :src="DetailData[0].EwmUrl" height="160" /></div>
             <p>请进群后添加指定的{{DetailData[0].OrderNum}}个微信号好友，好友验证暗号“{{DetailData[0].Validate}}”， <br />验证通过后请立即发送任意6条数字信息</p>
           </div>
         
          <div class="dl-footer">
            <span v-if="IsPub==0">发单者:{{DetailData[0].Nickname}}</span>
            <span v-else>接单者:{{DetailData[0].Nickname}}</span>
            <span v-if="IsPub==0">联系QQ:{{DetailData[0].ContactQQ}}</span>
            <span v-else>联系QQ:{{DetailData[0].QQ}}</span>
            <!-- 删除订单,接手订单,撤消订单,取消撤消,同意撤消,客服介入,取消介入,提交验收,取消验收,确认验收 -->
            <span class="fr" v-if="BtnShowArr[7]"><el-button type="primary" size="medium" @click="SubmitComplete">提交验收</el-button></span>
            <span class="fr" v-if="BtnShowArr[8]"><el-button type="primary" size="medium" @click="CancelComplete">取消验收</el-button></span>
            <span class="fr" v-if="BtnShowArr[9]"><el-button type="primary" size="medium" @click="ComfirmComplete">确认验收</el-button></span>
            <span class="fr" v-if="BtnShowArr[0]"><el-button type="primary" size="medium" @click="DelOrder">删除订单</el-button></span>
            <span class="fr" v-if="BtnShowArr[1]"><el-button type="primary" size="medium" @click="AcceptOrder">接手订单</el-button></span>
            <span class="fr" v-if="BtnShowArr[2]"><el-button type="primary" size="medium" @click="CancelOrder">撤消订单</el-button></span>
            <span class="fr" v-if="BtnShowArr[3]"><el-button type="primary" size="medium" @click="NoCancelOrder">取消撤消</el-button></span>
            <span class="fr" v-if="BtnShowArr[4]"><el-button type="primary" size="medium" @click="AgreeCancelOrder">同意撤消</el-button></span>
            <span class="fr" v-if="BtnShowArr[5]"><el-button type="primary" size="medium" @click="ArbitrationOrder">客服介入</el-button></span>
            <span class="fr" v-if="BtnShowArr[6]"><el-button type="primary" size="medium" @click="NoArbitrationOrder">取消介入</el-button></span>
          </div>
          
        </el-tab-pane>
        <el-tab-pane label="备忘" name="second" :disabled="IsPub==1?false:true" >
          <el-input size="small"  type="textarea" rows="6" v-model="comment" placeholder="可用于记录订单来源，客户联系方式，实际价格等，仅发单者可见……"></el-input>
           <div class="dl-footer">
            <span class="fr"><el-button type="primary" size="medium" @click="UpdateComment">保存</el-button></span>
            <span class="fr">仅发单者可见</span>
            
          </div>
        </el-tab-pane>
        <el-tab-pane label="截图" name="third" >
          <el-row align="middle" type="flex" class="mb20"> 
              <el-col :span="4"><div class="grid-content bg-purple">图片说明：</div></el-col>
              <el-col :span="20"><div class="grid-content bg-purple"><el-input size="medium" v-model="imgDec" placeholder="请填写图片内容说明……"></el-input></div></el-col>
          </el-row>
          <el-row align="middle" type="flex" class="mb20"> 
              <el-col :span="4"><div class="grid-content bg-purple">截图：</div></el-col>
              <el-col :span="13"><div class="grid-content bg-purple"><el-input size="medium" v-model="imgName" :disabled="true" ></el-input></div></el-col>
              <el-col :span="7"><div class="grid-content bg-purple fr">
                 <el-upload
                    class="upload-demo"
                    ref="upload"
                    :action="domain"
                    accept="image/jpeg,image/gif,image/png,image/bmp"
                    :headers="myHeader"
                    :http-request="uploadFile"
                    :on-change="changeFile"
                    :show-file-list="false"
                    :auto-upload="false"
                    list-type="picture"
                    :multiple="false">
                   <el-button slot="trigger" size="small" type="primary">选择图片</el-button>
                   <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload">上传</el-button>
                  </el-upload>   
              </div></el-col>
          </el-row>

           <el-table :data="tableData" height="480"  highlight-current-row  border >
            <el-table-column type="index" label="序号" width="60" header-align="center" align="center"  ></el-table-column>
            <el-table-column prop="CreateDate" label="时间"  width="160" align="center" :formatter="formatDate"></el-table-column>
            <el-table-column prop="Comment" label="图片说明" width="260" align="center"></el-table-column>
            <el-table-column prop="Nickname" label="上传者" width="100" align="center" ></el-table-column>
            <el-table-column label="操作" align="center" prop="Img" width="100" >
                <template slot-scope="scope">
                    <a class="show-img" :href="scope.row.Img" target="_blank">显示截图</a>
                </template>
            </el-table-column>
            </el-table>
            <div class="pagination fr">
            <el-pagination background layout="total, prev, pager, next" :total="totalCount" prev-text="上一页" next-text="下一页" :page-size="pageSize" :current-page="pageIndex" @current-change="handleCurrentChange">
            </el-pagination>
            </div>
        </el-tab-pane>
        <el-tab-pane label="订单留言" name="fourth" >
            <ul class="ordermsg" id="ordermsg">
              <li v-for="item in MsgListData" v-bind:key="item.ID">
                 <h3 :class="MsgTypeColor(item.MsgType,item.UserID)">{{MsgNickName(item.MsgType,item.UserID,item.Nickname)}}<span>{{ formatDate1(item.CreateDate) }}</span></h3>
                <p>{{ item.Msg }}</p>
              </li>
            </ul>
            <div class="dl-footer1">
              <el-row  align="middle"  type="flex" > 
                <el-col :span="4"><div class="grid-content bg-purple">消息内容：</div></el-col>
                <el-col :span="16"><div class="grid-content bg-purple"> <el-input size="small"  type="textarea" rows="2" v-model="msgTxt" ></el-input></div></el-col>
                <el-col :span="4"><div class="grid-content bg-purple"><span class="fr"><el-button type="primary" size="medium" @click="SendMsg">提交</el-button></span></div></el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
		</div>

    <!--   撤销订单   -->
    <cancelOrder :isShow="isShowCancelWindow" :Price="DetailData[0].Price" :Ensure="DetailData[0].Ensure" :IsPub="IsPub" :SerialNo="SerialNo" :Stamp="DetailData[0].Stamp"  @on-close="closeCancelWidow" @on-success="successCancelOrder"></cancelOrder>   
  </div>
</template>

<script>
import cancelOrder from "../components/cancelOrder"
export default {
  name: 'orderDetails',
  components: {cancelOrder: cancelOrder},
  props:{
    isShow:Boolean,
    OrderType:Number,
    SerialNo:String,
    IsPub:Number
  },
  data () {
    return {
       activeName: 'first',
       comment:'',
       imgDec:'',
       imgUrl:'',
       msgTxt:'',
       tableData:[],
       totalCount:0,
       pageIndex:1,
       isShowMe:this.isShow,
       DetailData:[{Title:'',Status:11,Price:0,Ensure:0}],
       fileUid:'',
       imgName:'',
       MsgListData:[],
       BtnShowArr:[false,false,false,false,false,false,false,false,false,false],        //删除订单,接手订单,撤消订单,取消撤消,同意撤消,客服介入,取消介入,提交验收,取消验收,确认验收
       timer:'',
       isShowCancelWindow:false,
       isSendMsg:false
    }
  },
  computed:{
     pageSize(){
				return this.$store.getters.pageSize;
      },
      Status(){
        return this.commonStatus();
      },
      domain(){
       return this.$store.getters.domain+'ImgBase64Upload1';
     },
     myHeader(){
       return {"content-type":"multipart/form-data"}
     },
     loading(){
       return this.$store.getters.loadingPara;
     },
     MsgTypeColor(){
       return function(msgType,userId) {
          //10：系统消息；    11：用户消息；      12：客服消息   13:订单状态改变
          if(msgType==10 || msgType==13)
            return "red";
          else if(msgType==11){
            var data= this.common.GetlocalStorage("UnLockUserData");
				    var userId1=JSON.parse(data).UserID;
            if(userId==userId1)
              return "blue";
            else
              return "green";
          }
          else if(msgType==12)
            return "red";
        }
     },
      MsgNickName(){
       return function(msgType,userId,nickName) {
          //10：系统消息；    11：用户消息；      12：客服消息     13:订单状态改变
          if(msgType==11)
            return nickName;
          else {
            return "系统消息";
          }
        }
     }
  },
  watch: {
    isShow(val) {
      this.isShowMe = val;
    },
    isShowMe(val){
      if(val){
        this.DetailInfo();
        this.ProgressList();
        //标记为已读
        this.ReadMsg();
      }else{
        this.$emit("on-close",val);
        if(this.timer!=""){
          window.clearInterval(this.timer); 
          this.timer="";
        }
      }
    }
  },
  methods: {
    closeWindow(){
			this.isShowMe=false;
    },
    closeCancelWidow(val){
      this.isShowCancelWindow=val;
    },
    handleCurrentChange(val){
				this.pageIndex=val;
			  this.ProgressList();
    },
    DetailInfo(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
        var userId=JSON.parse(data).UserID;
        const loading = this.$loading(this.loading);
				self.http.ajaxGet("LevelOrderDetail?UserID="+userId+"&OrderType="+self.OrderType+"&SerialNo="+self.SerialNo,function(res){
            loading.close();
            if(res.ReturnCode == 1){
              self.activeName='first';
              self.DetailData=res.Result;
              self.comment= self.DetailData[0].Comment;
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
            loading.close();
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
    },
    ProgressList(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
        var userId=JSON.parse(data).UserID;
        const loading = this.$loading(this.loading);
				self.http.ajaxGet("ProgressList?UserID="+userId+"&SerialNo="+self.SerialNo+"&PageSize="+self.pageSize+"&PageIndex="+self.pageIndex,function(res){
            loading.close();
						if(res.ReturnCode == 1){
              self.tableData=res.Result;
							self.totalCount=parseInt(res.Message);
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
            loading.close();
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
    },
    SendMsg(){
        if(this.isSendMsg){
           this.$message({ message: '订单已结束，无法进行留言', type: 'warning'});
        }else{
           if(this.msgTxt==""){
              this.$message({ message: '请输入消息内容', type: 'warning'});
           }else{
            const self = this;
            var data= self.common.GetlocalStorage("UnLockUserData");
            var userId=JSON.parse(data).UserID;
            const loading = this.$loading(this.loading);
            self.http.ajaxGet("SendMsg?UserID="+userId+"&SerialNo="+self.SerialNo+"&Msg="+self.msgTxt+"&IsPub="+self.IsPub,function(res){
                loading.close();
                if(res.ReturnCode == 1){
                  self.msgTxt='';
                  //刷新列表
                  self.MsgList();
                }else{
                  self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                }	
              },function(err){
                loading.close();
                self.$alert(err, '错误', {confirmButtonText: '确定'});
            })
          }
        }
    },
    MsgList(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
        var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("MsgList?UserID="+userId+"&SerialNo="+self.SerialNo+"&IsPub="+self.IsPub,function(res){
						if(res.ReturnCode == 1){
              self.MsgListData=res.Result;
              setTimeout(() => {
                var div=document.getElementById("ordermsg");
                div.scrollTop = div.scrollHeight;
              }, 200);
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
    },
    ReadMsg(){
      const self = this;
      var data= self.common.GetlocalStorage("UnLockUserData");
      var userId=JSON.parse(data).UserID;
      self.http.ajaxGet("ReadMsg?UserID="+userId+"&SerialNo="+self.SerialNo+"&IsPub="+self.IsPub,function(res){
            // if(res.ReturnCode == 1){
            //     self.Msgs=res.Result;
            // }else{
            //   self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
            // }	
          },function(err){
              //self.$alert(err, '错误', {confirmButtonText: '确定'});
      })
    },
    UpdateComment(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
        var userId=JSON.parse(data).UserID;
        var SerialNo=self.SerialNo;
        const loading = this.$loading(this.loading);
				self.http.ajaxGet("UpdateComment?UserID="+userId+"&SerialNo="+SerialNo+"&Comment="+self.comment,function(res){
            loading.close();
						if(res.ReturnCode == 1){
              self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
            loading.close();
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
    },
    changeFile(file,fileList){
       this.fileUid=file.uid;
       this.imgName=file.name;
    },
    checkUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isGIF = file.type === 'image/gif';
        const isPNG = file.type === 'image/png';
        const isBMP = file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isGIF && !isPNG && !isBMP) {
            this.$alert('上传图片必须是JPG/GIF/PNG/BMP 格式!', '提示', {confirmButtonText: '确定'});
        }else if(!isLt2M) {
            this.$alert('上传图片大小不能超过 2MB!', '提示', {confirmButtonText: '确定'});
        }
        return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    submitUpload() {
      if(this.imgDec=="")
          this.$message({ message: '请输入图片说明', type: 'warning'});
      else{
        if(this.imgName==''){
          this.$message({ message: '请选择一张图片', type: 'warning'}); 
        }else{
          this.$refs.upload.submit();
        }
      }
    },
    uploadFile: function (fileObj) {     //上传图片成功后发布订单
       const loading = this.$loading(this.loading);
       var file=fileObj.file;
       if(file.uid==this.fileUid){
        var b=this.checkUpload(file);
        if(b){
            const self = this;
            var reader = new FileReader();
            reader.onload = function(event) {
            // event.target.result 即为图片的Base64编码字符串
            var imsJson = [{
              "value": event.target.result,
              "name":'111'
            }];
            var json={"file":imsJson,"Comment":self.imgDec,"SerialNo":self.SerialNo,"IsPub":self.IsPub }
            self.http.ajaxPost('UploadProgress',json,"",function(data){
                loading.close();
                if(data.ReturnCode == 1){
                  self.imgDec='';
                  self.imgName='';
                  self.$alert('上传成功', '温馨提示', {confirmButtonText: '确定'});
                  self.ProgressList();
                }else{
                  self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
                }
            },function(res){ self.$alert(res, '错误', {confirmButtonText: '确定'});});
          }
          reader.readAsDataURL(file);
        }
      }
    },
    commonStatus(){
        var status=this.DetailData[0].Status;
        var cancelStatus=this.DetailData[0].CancelStatus;
        var cancelUserID=this.DetailData[0].CancelUserID;              //撤销订单用户编号
        var arbUserID=this.DetailData[0].ArbUserID;                    //客服介入订单用户编号        
        var data= this.common.GetlocalStorage("UnLockUserData");
        var userId=JSON.parse(data).UserID;
        this.BtnShowArr=[false,false,false,false,false,false,false,false,false,false];
        this.isSendMsg=false;
        if(status==11){
          if(this.IsPub==1)
            this.BtnShowArr[0]=true;
          else
            this.BtnShowArr[1]=true;
					return '未接手';
        }
				else if(status==12){
          this.BtnShowArr[2]=true;
					return '等待通知';
				}else if(status==13){
          this.isSendMsg=true;
					return "结算保费";
				}else if(status==14){
          if(this.IsPub==1)
            this.BtnShowArr[2]=true;
          else{
            this.BtnShowArr[2]=true;
            this.BtnShowArr[7]=true;
          }

          if(this.OrderType==1){
             return "进行中";
          }
					else{
            return "已通知解封";
          }
				}else if(status==15){
           if(this.IsPub==1){
               this.BtnShowArr[2]=true;
               this.BtnShowArr[9]=true;
           }else{
              this.BtnShowArr[2]=true;
              this.BtnShowArr[8]=true;
           }
					return "等待验收";
				}else if(status==17){
          this.isSendMsg=true;
					return "已结算";
				}else{
					if(cancelStatus==-1)
						return "所有";
          else if(cancelStatus==11)
          {
             if(this.IsPub==1) {
                if(userId==cancelUserID){             //发单者发起撤销
                    this.BtnShowArr[3]=true;
                    this.BtnShowArr[5]=true;
                }else{
                    this.BtnShowArr[4]=true;
                    this.BtnShowArr[5]=true;
                }
             }else{
                if(userId==cancelUserID){             //接单者发起撤销
                    this.BtnShowArr[3]=true;
                    this.BtnShowArr[5]=true;
                }else{
                    this.BtnShowArr[4]=true;
                    this.BtnShowArr[5]=true;
                }
             }
          	return "申请撤销中";
          }
					else if(cancelStatus==12){
            this.isSendMsg=true;
            return "协商已处理";
          }
					else if(cancelStatus==13)
						return "撤销已取消";
					else if(cancelStatus==14){
             if(this.IsPub==1) {
                if(userId==cancelUserID){          //发单者发起撤销
                    if(userId==arbUserID){         //发单者客服介入
                       this.BtnShowArr[6]=true;
                    }else{                         //接单者客服介入
                       this.BtnShowArr[3]=true;
                    }
                }else{                            
                    if(userId==arbUserID){         //发单者客服介入
                        this.BtnShowArr[4]=true;
                        this.BtnShowArr[6]=true;
                    }else{                         //接单者客服介入
                       this.BtnShowArr[4]=true;
                    }
                }
             }else{
                if(userId==cancelUserID){       //接单者发起撤销
                   if(userId==arbUserID){       //接单者客服介入      
                      this.BtnShowArr[6]=true;
                   }else{                       //发单者客服介入
                      this.BtnShowArr[3]=true;
                   }
                }else{                         //发单者发起撤销
                  if(userId==arbUserID){       //接单者客服介入      
                      this.BtnShowArr[6]=true;
                      this.BtnShowArr[4]=true;
                   }else{                       //发单者客服介入
                      this.BtnShowArr[3]=true;
                   }
                }
             }
	          return "客服介入中";
          }
					else if(cancelStatus==15){
             this.isSendMsg=true;
             return "客服已处理";
          }
					else if(cancelStatus==16){
             this.isSendMsg=true;
            return "客服强制撤销";
          }
        }
      },
      formatDate(row, column, cellValue){
          var crtTime = new Date(row.CreateDate);
          return this.http.dateFormat("yyyy-MM-dd hh:mm:ss",crtTime);
      },
      formatDate1(val){
          var crtTime = new Date(val);
          return this.http.dateFormat("yyyy-MM-dd hh:mm:ss",crtTime);
      },
      tabsHandleClick(tab, event) {
        if(tab.name=="fourth"){
          this.MsgList();
          this.timer = window.setInterval(this.MsgList,5000); 
        }else{
          if(this.timer!=""){
            window.clearInterval(this.timer); 
            this.timer="";
          }
        }
      },
      DelOrder(){
        const self = this;
        var data= self.common.GetlocalStorage("UnLockUserData");
        const loading = this.$loading(this.loading);
        var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("LevelOrderDel?UserID="+userId+"&SerialNo="+self.SerialNo,function(res){
            loading.close();
						if(res.ReturnCode == 1){
               //删除订单,接手订单,撤消订单,取消撤消,同意撤消,客服介入,取消介入,提交验收,取消验收,确认验收
               self.$emit("on-success","删除订单",self.OrderType);
               self.closeWindow();
               self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
            loading.close();
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
      },
      AcceptOrder(paypass){
        const self = this;
        var data= self.common.GetlocalStorage("UnLockUserData");
        const loading = this.$loading(this.loading);
        var userId=JSON.parse(data).UserID;
        var msg="请输入您的支付密码";
        this.$prompt(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder:'请输入您的支付密码',
        inputType:'password',
        inputPattern: /\S/,
        inputErrorMessage: '请输入您的支付密码'
        }).then(({ value }) => {
          self.http.ajaxGet("LevelOrderAccept?UserID="+userId+"&SerialNo="+self.SerialNo+"&Stamp="+this.DetailData[0].Stamp+"&PayPass="+paypass+"&IsApp=0",function(res){
          loading.close();
          if(res.ReturnCode == 1){
              self.$emit("on-success","接手订单",self.OrderType);
              self.closeWindow();
              self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
          }else{
            self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
          }	
          },function(err){
            loading.close();
            self.$alert(err, '错误', {confirmButtonText: '确定'});
          })
        }).catch(() => {  });
      },
      CancelOrder(){
        this.isShowCancelWindow=true;
      },
      NoCancelOrder(){
        const self = this;
        var data= self.common.GetlocalStorage("UnLockUserData");
        const loading = this.$loading(this.loading);
        var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("LevelOrderNoCancel?UserID="+userId+"&SerialNo="+self.SerialNo+"&Stamp="+this.DetailData[0].Stamp,function(res){
            loading.close();
						if(res.ReturnCode == 1){
               //删除订单,接手订单,撤消订单,取消撤消,同意撤消,客服介入,取消介入,提交验收,取消验收,确认验收
               self.$emit("on-success","取消撤销",self.OrderType);
               self.closeWindow();
               self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
            loading.close();
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
      },
      AgreeCancelOrder(){
        const self = this;
        var msg="请输入您的支付密码";
        this.$prompt(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder:'请输入您的支付密码',
        inputType:'password',
        inputPattern: /\S/,
        inputErrorMessage: '请输入您的支付密码'
        }).then(({ value }) => {
          var data= self.common.GetlocalStorage("UnLockUserData");
          var obj=JSON.parse(data);
          var userId=obj.UserID;
          const loading = this.$loading(this.loading);
          var paypass=self.http.get_pwd_hash(value,obj.uid);
          self.http.ajaxGet("LevelOrderAgreeCancel?UserID="+userId+"&SerialNo="+self.SerialNo+"&PayPass="+paypass+"&Stamp="+this.DetailData[0].Stamp,function(res){
          loading.close();
          if(res.ReturnCode == 1){
              self.$emit("on-success","同意撤消",self.OrderType);
              self.closeWindow();
              self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
          }else{
            self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
          }	
          },function(err){
            loading.close();
            self.$alert(err, '错误', {confirmButtonText: '确定'});
          })
        }).catch(() => {  });
      },
      ArbitrationOrder(){
        const self = this;
        var data= self.common.GetlocalStorage("UnLockUserData");
        const loading = this.$loading(this.loading);
        var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("LevelOrderArbitration?UserID="+userId+"&SerialNo="+self.SerialNo+"&Stamp="+this.DetailData[0].Stamp,function(res){
            loading.close();
						if(res.ReturnCode == 1){
               //删除订单,接手订单,撤消订单,取消撤消,同意撤消,客服介入,取消介入,提交验收,取消验收,确认验收
               self.$emit("on-success","客服介入",self.OrderType);
               self.closeWindow();
               self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
            loading.close();
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
      },
      NoArbitrationOrder(){
        const self = this;
        var data= self.common.GetlocalStorage("UnLockUserData");
        const loading = this.$loading(this.loading);
        var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("LevelOrderNoArbitration?UserID="+userId+"&SerialNo="+self.SerialNo+"&Stamp="+this.DetailData[0].Stamp,function(res){
            loading.close();
						if(res.ReturnCode == 1){
               //删除订单,接手订单,撤消订单,取消撤消,同意撤消,客服介入,取消介入,提交验收,取消验收,确认验收
               self.$emit("on-success","取消介入",self.OrderType);
               self.closeWindow();
               self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
            loading.close();
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
      },
      SubmitComplete(){
        const self = this;
        if(self.totalCount>=2){
          	var msg="您确定已完成订单解封，并已上传验证原因截图（该步骤含对方昵称和ID）和解封成功截图了吗？";
            	this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            	}).then(() => {
					
                var data= self.common.GetlocalStorage("UnLockUserData");
                const loading = this.$loading(this.loading);
                var userId=JSON.parse(data).UserID;
                self.http.ajaxGet("SubmitComplete?UserID="+userId+"&SerialNo="+self.SerialNo+"&Stamp="+this.DetailData[0].Stamp,function(res){
                    loading.close();
                    if(res.ReturnCode == 1){
                      //删除订单,接手订单,撤消订单,取消撤消,同意撤消,客服介入,取消介入,提交验收,取消验收,确认验收
                      self.$emit("on-success","提交验收",self.OrderType);
                      self.closeWindow();
                      self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
                    }else{
                      self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                    }	
                  },function(err){
                    loading.close();
                    self.$alert(err, '错误', {confirmButtonText: '确定'});
                })
					
             }).catch(() => { });
              
        }else{
          self.$alert('您上传的截图数量不足，请上传验证原因截图（该步骤含对方昵称和ID）和解封成功截图再提交验收。', '提示', {
          confirmButtonText: '去上传',
          callback: action => {self.activeName='third';}
          });
        }
      },
      CancelComplete(){
        const self = this;
        var data= self.common.GetlocalStorage("UnLockUserData");
        const loading = this.$loading(this.loading);
        var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("CancelComplete?UserID="+userId+"&SerialNo="+self.SerialNo+"&Stamp="+this.DetailData[0].Stamp,function(res){
            loading.close();
						if(res.ReturnCode == 1){
               //删除订单,接手订单,撤消订单,取消撤消,同意撤消,客服介入,取消介入,提交验收,取消验收,确认验收
               self.$emit("on-success","取消验收",self.OrderType);
               self.closeWindow();
               self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
					},function(err){
            loading.close();
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
      },
      ComfirmComplete(){
        const self = this;
        var msg="请输入您的支付密码";
        this.$prompt(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder:'请输入您的支付密码',
        inputType:'password',
        inputPattern: /\S/,
        inputErrorMessage: '请输入您的支付密码'
        }).then(({ value }) => {
          var data= self.common.GetlocalStorage("UnLockUserData");
          var obj=JSON.parse(data);
          var userId=obj.UserID;
          const loading = this.$loading(this.loading);
          var paypass=self.http.get_pwd_hash(value,obj.uid);
          self.http.ajaxGet("ComfirmComplete?UserID="+userId+"&SerialNo="+self.SerialNo+"&Stamp="+this.DetailData[0].Stamp+"&PayPass="+paypass,function(res){
          loading.close();
          if(res.ReturnCode == 1){
              self.$emit("on-success","确认验收",self.OrderType);
              self.closeWindow();
              self.$alert(res.Message, '提示', {confirmButtonText: '确定'});
          }else{
            self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
          }	
          },function(err){
            loading.close();
            self.$alert(err, '错误', {confirmButtonText: '确定'});
          })
        }).catch(() => {  });
      },
      successCancelOrder(){
        this.DetailInfo();
        this.$emit("on-success","撤消订单",self.OrderType);
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .detailList-bg{position:fixed;width:100%;height:100%;bottom:0;background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:99; }
	.detailList{width:740px;height:820px;position: fixed; top:50%; left:50%; margin-left:-370px; margin-top:-410px;  z-index:999; background: #fff; }
	.detailList .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
	.detailList .dl-title{ font-size:20px; color:#444; margin-left:45px;}
	.detailList .dl-close{ margin-right:25px; margin-top:8px;}
	.detailList .dl-close img{ cursor: pointer;}
  .detailList .dl-footer{height:60px; line-height:60px; font-size:16px; color:#444; background: #eee; position:fixed; bottom:50px; width:680px; padding:0 30px; margin-left:-30px;}
  .detailList .dl-footer1{height:60px;  font-size:16px; color:#444; background: #eee; position:fixed; bottom:50px; width:680px; padding:15px 30px 0; margin-left:-30px;}
  .detailList .dl-footer span{ padding-right:20px;}
  .detailList .eltabs{padding:0 30px;font-size:16px; color:#444;}

  .orderinfo{height:75px; line-height:28px; background: #eef2f9; padding:15px 20px 0;}
  .orderinfo span{color:#4885f0;}
  h2{font-size:18px; color:#444; display:inline-block; padding:20px 0; font-weight: normal;} 
  em{font-size:16px; color:#999;}
  .weixin{ height:120px;background: #eef2f9; padding:15px 20px;  }
  .wxqun p{ color:#e15454; font-size:16px; width:68%; line-height: 28px;}
  .pagination{margin:40px 0 0;}

  .red{color:#ef5c5c;}
  .blue{color:#5190ff;}
  .green{color:#009868;}
  .mb20{margin-bottom:20px;}

  .ordermsg {font-size:18px; height: 600px; overflow-y: scroll;}
  .ordermsg span{ padding-left:10px; font-size:17px;}
  .ordermsg h3{ font-weight: normal;}
  .ordermsg li{  padding-bottom:20px;}
  .ordermsg p{ padding-top:10px; font-size:16px; color:#444; line-height: 24px;}
  .unlockWxOne{ color:#5190FF; font-size:18px;padding: 20px 0 0;}

  .show-img{ text-decoration: none; color:#409EFF;}
</style>



// WEBPACK FOOTER //
// src/components/orderDetails.vue